import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "sea_confirmation_modal",
  class: "modal fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  ref: "vDom"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
], -1)
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, [
            _renderSlot(_ctx.$slots, "title")
          ]),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", null, [
            _renderSlot(_ctx.$slots, "body")
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(`btn ${_ctx.noButtonStyle}`),
            "data-bs-dismiss": "modal"
          }, [
            _renderSlot(_ctx.$slots, "noButton")
          ], 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(`btn ${_ctx.okButtonStyle}`),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.okClick && _ctx.okClick(...args)))
          }, [
            _renderSlot(_ctx.$slots, "okButton")
          ], 2)
        ])
      ])
    ])
  ], 512))
}